export const TRANSLATION_KEY_REGEXP = /^[A-Z][A-Z0-9-_.]*$/;
